import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
@Component({
  selector: 'cigna-header-logo',
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss'],
})
export class HeaderLogoComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() resizeSideNavToggle: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() enableToggleSidNav: boolean;
  @Input() isFromLogin: boolean;
  @Input() isImpersonator: boolean;
  @Output() resizeSideNavToggleEmit = new EventEmitter<{ open: boolean }>();

  constructor() {}
  ngOnInit(): void {}
  resizeSideNavToggleFn(): void {
    this.resizeSideNavToggle = !this.resizeSideNavToggle;
    this.resizeSideNavToggleEmit.next({ open: this.resizeSideNavToggle });
  }
}
